import { PagesContext } from "providers/Pages";
import React, { createContext, useContext, useEffect, useState } from "react";

export type ArticleContextType = {
  articleId: string;
  articles: Array<any>;
  isLoaded: boolean;
  viewed: Array<string>;
  setIsLoaded: (p: boolean) => void;
  clearState: () => void;
};

export const ArticleContext = createContext<ArticleContextType>(
  {} as ArticleContextType
);

const ArticleProvider = ({ children }) => {
  const pagesContext = useContext(PagesContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [viewed, setViewed] = useState<Array<string>>([]);

  function handleClearStates() {
    setIsLoaded(false);
    setViewed([]);
  }

  return (
    <ArticleContext.Provider
      value={{
        articleId: pagesContext?.articles?.[0]?.id || "",
        articles: pagesContext.articles,
        isLoaded,
        viewed,
        setIsLoaded,
        clearState: handleClearStates,
      }}
    >
      {children}
    </ArticleContext.Provider>
  );
};

export default ArticleProvider;
